import CLientVendorsPage from "./ClientVendorsPage";
import ManageUserPanel from "./ManageUsers";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ManageProjectsPermissionsTab from "./ManageProjectsPermissionsTab";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

export const adminPanelTabs = () => {
  return [
    {
      id: "users",
      label: "Manage Users",
      panel: <ManageUserPanel />,
      icon: <EngineeringIcon fontSize="small" />,
    },

    {
      id: "projects",
      label: "Projects & Permissions",
      panel: <ManageProjectsPermissionsTab />,
      icon: <AdminPanelSettingsIcon fontSize="small" />,
    },
    {
      id: "timesheets",
      label: "Time Sheets",
      panel: <ManageProjectsPermissionsTab />,
      icon: <AccountTreeIcon fontSize="small" />,
    },

    {
      id: "vendors",
      label: "Company Vendors",
      panel: <CLientVendorsPage />,
      icon: <PeopleAltIcon fontSize="small" />,
    },
  ];
};
